module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_detail') === -1 && _vm.$route.path.indexOf('_editor') === -1) ? _c('div', [_c('el-row', {
    staticClass: "content-bottom-padded",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n        开启体测： "), _c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.setting.status),
      callback: function($$v) {
        _vm.$set(_vm.setting, "status", $$v)
      },
      expression: "setting.status"
    }
  })], 1)], 1), _vm._v(" "), (_vm.setting.status == 1) ? _c('el-row', {
    staticClass: "content-bottom-padded",
    attrs: {
      "gutter": 20
    }
  }, [(_vm.setting.status == 1 && _vm.setting.temp_id != 0) ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', [_vm._v("当前体测模板：" + _vm._s(_vm.setting.temp_name))])]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.batchChooseFormwork
    }
  }, [_vm._v("选择体测模板")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.setting.status == 1 && _vm.setting.temp_id != 0) ? _c('el-card', {
    attrs: {
      "shadow": "never"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.ItemsList,
      "height": _vm.wheight - 280
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": "会员手机号",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "姓名",
      "width": "120"
    }
  }), _vm._v(" "), _vm._l((_vm.colsTitle), function(col, index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "prop": col.prop,
        "label": col.label,
        "width": "100"
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          staticClass: "iconfont icon-search-plus",
          on: {
            "click": function($event) {
              return _vm.goToDetail(scope.$index, scope.row)
            }
          }
        }, [_vm._v("详情")])]
      }
    }], null, false, 3656209137)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [10, 20, 50],
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "right-dialog",
    attrs: {
      "title": "选择体侧模板",
      "visible": _vm.FormworkVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.FormworkVisible = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "formwork",
      attrs: {
        "model": _vm.formwork
      }
    }, [_c('el-form-item', [_c('el-radio-group', {
      model: {
        value: (_vm.formwork.resource),
        callback: function($$v) {
          _vm.$set(_vm.formwork, "resource", $$v)
        },
        expression: "formwork.resource"
      }
    }, _vm._l((_vm.FormworkList), function(item, index) {
      return _c('el-radio', {
        key: index,
        attrs: {
          "label": item.id
        }
      }, [_vm._v(_vm._s(item.tem_name))])
    }), 1)], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-center"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.onSubmitFormwork
      }
    }, [_vm._v("确定添加")])], 1)], 1)]
  ], 2)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3465fc66", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3465fc66"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/selfservice/templatepreview.vue
// module id = 2608
// module chunks = 0